
import { useAppState } from "src/state";

import { AgencyOperationsAdminVenueViewSchema } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueViewSchema";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";


export function AgencyOperationsAdminVenueView() {

    const { currentItem } = useAppState().tenants;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={AgencyOperationsAdminVenueViewSchema}
            data={currentItem}
            title="Venue Overview"
            icon={Icons.venue}
        />
    );
}